import Card from './Card';
import CadrQuestion from './CardQuestion';

Card.Question = CadrQuestion;

export default Card;
